import { useMutation } from "@tanstack/react-query";
import { createDirectDebit } from "src/services";
import { CheckoutError } from "src/types/error";

const useCreateDirectDebit = () => {
  return useMutation<
    DirectDebitAuthorizationResponse,
    CheckoutError,
    { token: string | undefined; data: DirectDebitData }
  >({
    mutationFn: ({ token, data }) => createDirectDebit(token, data),
  });
};

export default useCreateDirectDebit;
